import { useSelector } from 'react-redux';

export default resourceId =>
  useSelector(({ ui }) => ui?.options?.people?.find(({ id }) => id === resourceId));
